module.exports = __webpack_public_path__ + "static/img/3143_phase_function_Paper_PointsHejduk_Prediction.ce2dd8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3143_phase_function_Paper_PointsHejduk_Prediction.png
// module id = xyuP
// module chunks = 0